import React from 'react';
import { Card, CardContent } from './ui/card';
import { MapPin, Phone, Clock, Instagram, Facebook, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mock';

const Contact = ({ t, lang }) => {
  return (
    <section id="contact" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.contact.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact Info Cards */}
          <div className="space-y-6">
            {/* Address */}
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/50 transition-colors">
              <CardContent className="flex items-start space-x-4 p-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">{t.contact.address}</h3>
                  <p className="text-gray-400">{contactInfo.address}</p>
                  <a
                    href={contactInfo.maps}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-amber-400 hover:text-amber-300 text-sm mt-2 inline-block"
                  >
                    {lang === 'id' ? 'Lihat di Maps' : 'View on Maps'} →
                  </a>
                </div>
              </CardContent>
            </Card>

            {/* Phone & WhatsApp */}
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/50 transition-colors">
              <CardContent className="flex items-start space-x-4 p-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-black" />
                </div>
                <div className="flex-1">
                  <h3 className="text-white font-semibold text-lg mb-1">{t.contact.phone}</h3>
                  <p className="text-gray-400 mb-3">{contactInfo.phone}</p>
                  <a
                    href={`https://wa.me/${contactInfo.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="bg-green-600 hover:bg-green-700 text-white">
                      <MessageCircle className="w-4 h-4 mr-2" />
                      WhatsApp
                    </Button>
                  </a>
                </div>
              </CardContent>
            </Card>

            {/* Operating Hours */}
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/50 transition-colors">
              <CardContent className="flex items-start space-x-4 p-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-lg mb-1">{t.contact.hours}</h3>
                  <p className="text-gray-400">{contactInfo.hours[lang].weekday}</p>
                  <p className="text-gray-400">{contactInfo.hours[lang].weekend}</p>
                </div>
              </CardContent>
            </Card>

            {/* Social Media */}
            <Card className="bg-gray-900 border-gray-800">
              <CardContent className="p-6">
                <h3 className="text-white font-semibold text-lg mb-4">{t.contact.social}</h3>
                <div className="flex space-x-4">
                  <a
                    href={contactInfo.social.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded-lg flex items-center justify-center hover:scale-110 transition-transform"
                  >
                    <Instagram className="w-6 h-6 text-white" />
                  </a>
                  <a
                    href={contactInfo.social.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center hover:scale-110 transition-transform"
                  >
                    <Facebook className="w-6 h-6 text-white" />
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Map */}
          <div className="h-full min-h-[500px]">
            <Card className="bg-gray-900 border-gray-800 h-full">
              <CardContent className="p-0 h-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.9856974087447!2d98.6765!3d3.5952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwMzUnNDIuNyJOIDk4wrA0MCczNS40IkU!5e0!3m2!1sen!2sid!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '500px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg"
                  title="KETUA BARBERSHOP Location"
                ></iframe>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
